import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    SectionWrapper,
    LimitsConfirmationWrapper,
    ConfirmationDescription,
    ToggleWrapper,
} from 'src/domains/players/webview/components/SignUp/signupPrimary/signUpViews/responsibleGambling/ResponsibleGambling.style';
import { Toggle } from 'src/components/toggle/Toggle';
import { LimitsConfirmationState } from 'src/domains/players/webview/components/SignUp/signupPrimary/signupState/stepsStructure/responsibleGambling/LimitsConfirmation.state';

interface LimitsConfirmationFormPropsType {
    state: LimitsConfirmationState;
}

export const LimitsConfirmation = observer('LimitsConfirmation', ({ state }: LimitsConfirmationFormPropsType) => {
    return (
        <SectionWrapper data-test='limits-confirmation'>
            <LimitsConfirmationWrapper>
                <ConfirmationDescription data-test='limits-confirmation-description'>
                    <I18n
                        langKey='signup-journey.limits-confirmation-description'
                        defaultText="I've looked at my deposit limit options and I'm happy with my current choice, even if I've decided not to set one right now."
                    />
                </ConfirmationDescription>
                <ToggleWrapper>
                    <Toggle
                        toggleActive={state.toggleCheckBoxValue}
                        isActive={state.checkBoxValue}
                        variant='dark'
                    />
                </ToggleWrapper>
            </LimitsConfirmationWrapper>
        </SectionWrapper>
    );
});
